import HomeSmartApi from '@/modules/backend/HomeSmartApi';
import axios from 'axios';
import store from '@/store';

const instance = axios.create();

const homeSmartApi = new HomeSmartApi(instance);

homeSmartApi.rest.OnError = (message: string): void => {
  store.commit('app/errors/add', message);
  console.log('Rest Error', message);
};

homeSmartApi.rest.OnLogout = (): void => {
  store.commit('app/auth/IsAuth', false);
};

homeSmartApi.rest.OnLogin = (): void => {
  store.commit('app/auth/IsAuth', true);
};

export default (homeSmartApi);
